// extracted by mini-css-extract-plugin
export default {"markdown":"Chatbot_markdown__O-u1e"};